import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CityDropdownComponent } from './city-dropdown.component';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import { ParameterService } from '../../utils/services/parameter.service';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    ReactiveFormsModule
  ],
  declarations: [CityDropdownComponent],
  exports: [CityDropdownComponent]
})
export class CityDropdownModule { }



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/city-dropdown/city-dropdown.module.ts